import styled from 'styled-components';
import { Header as HeaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
`;

export const Image = styled.img`
  width: 60px;
`;

export const Text = styled(HeaderLayoutComponent)`
  text-align: center;
  max-width: 600px;
`;
